/* PACCO Header — scripts inline consolidados de sections/header.liquid (sem dependência Liquid). */


/* ===== bloco originalmente em header.liquid linhas 1594-1616 ===== */
(function(){
  const navCE = document.querySelector('desktop-navigation');
  if(!navCE) return;

  const sync = () => {
    const anyOpen = navCE.querySelector('[aria-controls][aria-expanded="true"]');
    document.body.classList.toggle('pacco-mega-open', !!anyOpen);
  };

  // Observa qualquer mudança de aria-expanded no menu
  const mo = new MutationObserver(sync);
  mo.observe(navCE, { subtree: true, attributes: true, attributeFilter: ['aria-expanded'] });

  // Ainda escuta mouseleave pra garantir o fechamento
  const navRoot = document.getElementById('pacco-nav');
  if (navRoot) navRoot.addEventListener('mouseleave', () => setTimeout(sync, 10), {passive:true});

  // Sync inicial
  document.addEventListener('DOMContentLoaded', sync);
  window.addEventListener('load', sync);
})();

/* ===== bloco originalmente em header.liquid linhas 1618-1685 ===== */
(function(){
  const nav = document.getElementById('pacco-nav');
  if (!nav) return;

  const GUTTER = 16;

  function adjust(dropdown){
    if (!dropdown || dropdown.hasAttribute('hidden')) return;

    dropdown.style.left = '';
    dropdown.style.right = '';
    dropdown.style.marginLeft = '';
    dropdown.style.marginRight = '';

    const rect = dropdown.getBoundingClientRect();
    const vw = window.innerWidth || document.documentElement.clientWidth || 0;

    if (rect.width >= vw) {
      dropdown.style.left = GUTTER + 'px';
      dropdown.style.right = GUTTER + 'px';
      dropdown.style.marginLeft = '0';
      dropdown.style.marginRight = '0';
      return;
    }

    if (rect.right > vw - GUTTER) {
      const shift = rect.right - (vw - GUTTER);
      dropdown.style.left = 'auto';
      dropdown.style.right = Math.max(shift, 0) + 'px';
      dropdown.style.marginLeft = '0';
      dropdown.style.marginRight = '0';
    } else if (rect.left < GUTTER) {
      const shift = GUTTER - rect.left;
      dropdown.style.right = 'auto';
      dropdown.style.left = Math.max(shift, 0) + 'px';
      dropdown.style.marginLeft = '0';
      dropdown.style.marginRight = '0';
    }
  }

  function adjustFrom(trigger){
    if (!trigger) return;
    trigger.querySelectorAll('.nav-dropdown:not([hidden])').forEach(adjust);
  }

  function schedule(trigger){
    if (!trigger || !nav.contains(trigger)) return;
    requestAnimationFrame(function(){ adjustFrom(trigger); });
  }

  nav.addEventListener('mouseenter', function(event){
    schedule(event.target.closest('.header__linklist-item, .nav-dropdown__item'));
  }, true);

  nav.addEventListener('focusin', function(event){
    schedule(event.target.closest('.header__linklist-item, .nav-dropdown__item'));
  });

  document.addEventListener('desktop-nav:dropdown:open', function(event){
    schedule(event.target.closest('.header__linklist-item, .nav-dropdown__item'));
  }, true);

  window.addEventListener('resize', function(){
    nav.querySelectorAll('.nav-dropdown:not([hidden])').forEach(adjust);
  });
})();

/* ===== bloco originalmente em header.liquid linhas 1687-1711 ===== */
/* PACCO: detector de topo estável (sem “pisca”) */
(function(){
  const root = document.documentElement;
  const TH = 8; // tolerância maior para micro-scrolls
  let ticking = false;

  function atTop(){
    const y = window.scrollY ?? window.pageYOffset ?? document.documentElement.scrollTop ?? 0;
    return y <= TH;
  }
  function sync(){
    root.classList.toggle('pacco-at-top', atTop());
  }
  function onScroll(){
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => { ticking = false; sync(); });
  }

  window.addEventListener('scroll', onScroll, {passive:true});
  document.addEventListener('DOMContentLoaded', sync);
  window.addEventListener('load', sync);
})();

/* ===== bloco originalmente em header.liquid linhas 1915-1930 ===== */
(function(){
  const IDS = ['predictive-inline-desktop','predictive-inline-mobile'];
  const isOpen = () => IDS.some(id => {
    const el = document.getElementById(id);
    return el && !el.hasAttribute('hidden');
  });
  function sync() { document.body.classList.toggle('pacco-search-open', isOpen()); }
  IDS.forEach(id=>{
    const el = document.getElementById(id);
    if (!el) return;
    new MutationObserver(sync).observe(el, { attributes:true, attributeFilter:['hidden'] });
  });
  sync();
})();

/* ===== bloco originalmente em header.liquid linhas 1932-1952 ===== */
(function(){
  function equalize(menu){
    var wrap = menu.querySelector('.mega-menu__columns-wrapper');
    if(!wrap) return;
    var cols = wrap.querySelectorAll('.mega-menu__column');
    var max = 0;
    cols.forEach(function(c){ var w = c.scrollWidth; if (w > max) max = w; });
    if(max){ menu.style.setProperty('--mega-col-w', Math.ceil(max) + 'px'); }
  }
  function runAll(){ document.querySelectorAll('#pacco-nav .mega-menu').forEach(equalize); }
  document.addEventListener('DOMContentLoaded', runAll);
  window.addEventListener('resize', runAll);
  document.querySelectorAll('#pacco-nav .header__linklist-item').forEach(function(item){
    item.addEventListener('mouseenter', function(){
      var menu = item.querySelector('.mega-menu');
      if(menu) equalize(menu);
    });
  });
})();

/* ===== bloco originalmente em header.liquid linhas 1975-2014 ===== */
/* Desktop Colorboard usando o Core — robusto com retry */
(function(){
  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  function mountDesktop(){
    var ok = !!(window.PaccoHeader && window.PaccoHeader.colorboard && window.PaccoHeader.colorboard.renderDesktop);
    if (!ok) return false;
    var list = document.querySelectorAll('[data-colorboard="desktop"]');
    Array.prototype.forEach.call(list, function(el){
      if (el.dataset.mounted) return;
      el.dataset.mounted = '1';
      try{ window.PaccoHeader.colorboard.renderDesktop(el); }catch(e){ console.error(e); }
    });
    return true;
  }

  function attachLazyTriggers(){
    var mms = document.querySelectorAll('.mega-menu--colorboard');
    Array.prototype.forEach.call(mms, function(mm){
      var li = mm.closest('.header__linklist-item');
      if (!li) return;
      var once = function(){ mountDesktop(); li.removeEventListener('mouseenter', once); li.removeEventListener('focusin', once); };
      li.addEventListener('mouseenter', once, { once:true });
      li.addEventListener('focusin',  once, { once:true });
    });
  }

  function tryMountWithRetry(retries){
    if (retries == null) retries = 60; // 60 * 100ms = 6s total
    if (mountDesktop()){ attachLazyTriggers(); return; }
    if (retries <= 0) { attachLazyTriggers(); return; }
    setTimeout(function(){ tryMountWithRetry(retries-1); }, 100);
  }

  ready(function(){
    tryMountWithRetry(60);
  });
})();

/* ===== bloco originalmente em header.liquid linhas 2016-2134 ===== */
(function(){
  const root = document.querySelector('#pacco-nav');
  if(!root) return;

  const getActiveTrigger = (col) =>
    col.querySelector(':scope > .nav-dropdown__link[aria-expanded="true"]') ||
    col.querySelector(':scope > .nav-dropdown__link[aria-controls]');

  function setPanelTop(col, trigger){
    const panel = col.querySelector(':scope > .nav-dropdown2');
    if(!panel) return;
    const link = trigger || getActiveTrigger(col);
    if(!link){
      panel.style.removeProperty('--submenu2-top');
      return;
    }
    const linkRect = link.getBoundingClientRect();
    const colRect  = col.getBoundingClientRect();
    const offset   = Math.max(0, linkRect.top - colRect.top);
    panel.style.setProperty('--submenu2-top', `${offset}px`);
  }

  function fit(col, trigger){
    const menu  = col.closest('.mega-menu');
    const panel = col.querySelector(':scope > .nav-dropdown2');
    if(!menu || !panel) return;

    setPanelTop(col, trigger);

    const prevVis = panel.style.visibility;
    const prevDisp = panel.style.display;
    panel.style.visibility = 'hidden';
    panel.style.display = 'block';

    requestAnimationFrame(()=>{
      const marginW = 12;
      const r1 = panel.getBoundingClientRect();
      col.toggleAttribute('data-open-left', r1.right > (window.innerWidth - marginW));

      const menuRect = menu.getBoundingClientRect();
      const r2 = panel.getBoundingClientRect();
      const marginH = 8;
      const extra = Math.max(0, Math.ceil(r2.bottom + marginH - menuRect.bottom));
      menu.style.setProperty('--mega-extra-h', extra ? extra + 'px' : '0px');

      panel.style.visibility = prevVis;
      panel.style.display = prevDisp;
    });
  }

  function alignPanel({ item, selector, cssVar }){
    const panel = item.querySelector(selector);
    if(!panel) return;

    const menu = item.closest('.nav-dropdown');
    if(!menu) return;

    requestAnimationFrame(()=>{
      const link = item.querySelector(':scope > .nav-dropdown__link');
      const ref  = link || item;

      const refRect  = ref.getBoundingClientRect();
      const itemRect = item.getBoundingClientRect();

      const offset = Math.round(refRect.top - itemRect.top);
      const value = `${offset}px`;

      panel.style.setProperty(cssVar || '--submenu-top', value);
    });
  }

  const alignColorboard = (item) =>
    alignPanel({ item, selector: ':scope > .cb-dropdown', cssVar: '--cb-dropdown-top' });

  function alignSimpleSubmenu(item){
    alignPanel({ item, selector: ':scope > .nav-dropdown:not(.cb-dropdown)', cssVar: '--submenu-top' });
  }

  root.querySelectorAll('.mega-menu__column.has-dropdown').forEach(col=>{
    const triggers = col.querySelectorAll(':scope > .nav-dropdown__link[aria-controls]');
    triggers.forEach(link=>{
      link.addEventListener('mouseenter', ()=> fit(col, link));
      link.addEventListener('focus',      ()=> fit(col, link));
    });

    col.addEventListener('mouseenter', ()=> fit(col));
    col.addEventListener('focusin',    ()=> fit(col));
  });

  root.querySelectorAll('.nav-dropdown__item.has-dropdown').forEach(item=>{
    const handler = () => {
      alignSimpleSubmenu(item);
      alignColorboard(item);
    };
    const link = item.querySelector(':scope > .nav-dropdown__link');
    if(link){
      link.addEventListener('mouseenter', handler);
      link.addEventListener('focus',      handler);
    }
    item.addEventListener('mouseenter', handler);
    item.addEventListener('focusin',    handler);
  });

  root.addEventListener('mouseleave', ()=>{
    document.querySelectorAll('#pacco-nav .mega-menu')
      .forEach(m => m.style.setProperty('--mega-extra-h','0px'));
  });

  window.addEventListener('resize', ()=>{
    document.querySelectorAll('#pacco-nav .mega-menu')
      .forEach(m => m.style.setProperty('--mega-extra-h','0px'));
    root.querySelectorAll('.nav-dropdown__item.has-dropdown').forEach(item=>{
      alignSimpleSubmenu(item);
      alignColorboard(item);
    });
  });
})();

/* ===== bloco originalmente em header.liquid linhas 2136-2199 ===== */
(function(){
  const root = document.documentElement;
  const sec  = document.querySelector('.shopify-section--announcement-bar');
  if (!sec) { root.style.setProperty('--announcement-bar-height','0px'); root.style.setProperty('--announcement-offset','0px'); return; }

  const el = sec.firstElementChild || sec;

  const setH   = px => root.style.setProperty('--announcement-bar-height', (px|0) + 'px');
  const setOff = px => root.style.setProperty('--announcement-offset',    (px|0) + 'px');
  const readH  = () => (el.offsetHeight || sec.offsetHeight || 0) | 0;

  // Só fica true após rolagem REAL (>1px). Ignora scrolls de teste.
  let hasScrolled = false;

  // Evita "subida" do header se a barra variar de altura sozinha (ex: iframe/carrossel)
  // Antes do primeiro scroll do usuário, usamos sempre a MAIOR altura vista.
  let maxHBeforeScroll = 0;

  function measureSticky(){
    const h = readH();
    setH(h);
    setOff(h);
  }

  function syncNonSticky(){
    const h = readH();
    maxHBeforeScroll = Math.max(maxHBeforeScroll, h);
    setH(h);

    const y = window.scrollY || window.pageYOffset || 0;
    const onTop = !hasScrolled || y <= 1;

    // Antes do 1º scroll real, travamos no maior h (não deixa o header "subir").
    const effectiveH = !hasScrolled ? maxHBeforeScroll : h;
    setOff(onTop ? effectiveH : 0);
  }

  function isStickyNow(){
    const ps = getComputedStyle(sec).position;
    const pe = getComputedStyle(el).position;
    return /sticky/i.test(ps) || /sticky/i.test(pe);
  }

  // Reavalia o modo sticky/non-sticky a cada tick (apps/CSS podem mudar isso tarde)
  function sync(){
    if (isStickyNow()) measureSticky(); else syncNonSticky();
  }

  const ro = new ResizeObserver(sync);
  ro.observe(el);

  window.addEventListener('scroll', () => {
    if (window.__paccoTesting) return;        // ignora o scroll do teste do sticky
    if ((window.scrollY || window.pageYOffset || 0) > 1) hasScrolled = true;
    sync();
  }, { passive: true });

  window.addEventListener('resize',  sync, { passive: true });
  window.addEventListener('load',    sync);
  document.addEventListener('DOMContentLoaded', sync);
  sync();
})();

/* ===== bloco originalmente em header.liquid linhas 2201-2252 ===== */
(function(){
  const HOVER_DELAY = 40;
  const TOUCH_DELAY = 0;
  const MOBILE = window.matchMedia('(max-width: 740px)').matches;
  const cache = new Map();

  function prefetch(url) {
    if (!url || cache.has(url)) return;
    try {
      const u = new URL(url, location.origin);
      if (u.origin !== location.origin) return;
      const ctrl = new AbortController();
      cache.set(u.toString(), {
        promise: fetch(u.toString(), { credentials:'same-origin', signal:ctrl.signal }).then(r => r.ok ? r.text() : null).catch(()=>null),
        ctrl
      });
      setTimeout(() => ctrl.abort(), 8000);
    } catch(_) { /* ignore */ }
  }

  function wire(root){
    root.querySelectorAll('a[href]').forEach(a=>{
      const href = a.getAttribute('href');
      if (!href || href[0] === '#') return;
      if (a.dataset.noPrefetch === '1') return;

      const url = new URL(href, location.origin).toString();
      let tid;
      a.addEventListener('mouseenter', ()=>{ tid = setTimeout(()=>prefetch(url), HOVER_DELAY); }, {passive:true});
      a.addEventListener('mouseleave', ()=> clearTimeout(tid), {passive:true});
      /* touchstart prefetch no mobile deixa a aba do Safari em loading contínuo */
      if (!MOBILE) {
        a.addEventListener('touchstart', ()=> setTimeout(()=>prefetch(url), TOUCH_DELAY), {passive:true});
      }
    });
  }

  document.addEventListener('DOMContentLoaded', ()=>{
    ['#pacco-nav','.pacco-desktop-search','.pacco-mobile-search','#predictive-inline-desktop','#predictive-inline-mobile']
      .map(sel => document.querySelector(sel))
      .filter(Boolean)
      .forEach(wire);

    ['predictive-inline-desktop','predictive-inline-mobile'].forEach(id=>{
      const el = document.getElementById(id);
      if (!el) return;
      new MutationObserver(muts=>{
        muts.forEach(m=> m.addedNodes.forEach(n=> n.querySelectorAll && wire(n)));
      }).observe(el, {childList:true, subtree:true});
    });
  });

  window.__paccoHtmlCache = cache;
})();

/* ===== bloco originalmente em header.liquid linhas 2254-2325 ===== */
(function(){
  const SEL = [
    '.popular-searches .predictive-search__linklist-link',
    '#pacco-psx [data-type="queries"] .predictive-search__linklist-link'
  ].join(',');

  function ensureInlineLoader(container){
    if(container.querySelector('.pacco-local-loader')) return;
    const box = document.createElement('div');
    box.className = 'pacco-local-loader';
    box.innerHTML = `
      <div class="pacco-topbar" aria-hidden="true"></div>
      <div class="pacco-spinner" role="status" aria-label="Carregando"></div>
      <div class="msg" role="status" aria-live="polite">Buscando produtos…</div>
    `;
    container.appendChild(box);
  }
  function showInlineLoader(container){
    ensureInlineLoader(container);
    container.querySelector('.pacco-local-loader').classList.add('is-on');
  }

  function showDrawerLoader(drawer){
    const loading = drawer.querySelector('.predictive-search__loading-state');
    const sugg    = drawer.querySelector('.predictive-search__suggestions');
    const results = drawer.querySelector('.predictive-search__results');
    if(loading){
      if(!loading.querySelector('.pacco-loading-msg')){
        const m = document.createElement('div');
        m.className = 'pacco-loading-msg';
        m.setAttribute('role','status');
        m.setAttribute('aria-live','polite');
        m.textContent = 'Buscando produtos…';
        loading.appendChild(m);
      }
      loading.hidden = false;
    }
    if(sugg)    sugg.hidden = true;
    if(results) results.hidden = true;
    drawer.setAttribute('aria-busy','true');
  }

  function onClick(e){
    const a = e.target && e.target.closest && e.target.closest(SEL);
    if(!a) return;
    if(e.defaultPrevented) return;
    if(e.button !== 0) return;
    if(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    const href = a.getAttribute('href'); if(!href) return;
    let url; try{ url = new URL(href, location.origin); }catch(_){ return; }
    if(url.origin !== location.origin) return;

    const drawer = a.closest('predictive-search-drawer');
    const inline = a.closest('.predictive-inline');

    if(drawer){ showDrawerLoader(drawer); }
    else if(inline){ showInlineLoader(inline); }

    e.preventDefault();
    requestAnimationFrame(()=> setTimeout(()=> location.assign(url.toString()), 30));
  }

  window.addEventListener('pageshow', ()=>{
    document.querySelectorAll('predictive-search-drawer[aria-busy="true"]').forEach(d=>d.removeAttribute('aria-busy'));
    document.querySelectorAll('.pacco-local-loader.is-on').forEach(el=>el.classList.remove('is-on'));
  });

  document.addEventListener('click', onClick, {capture:true});
})();

